import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuxiliaryRequestState, RequestState } from '@shs-digi-care-monorepo/interfaces';
import { statusColorMap } from '../requests-status-pill/config/status-color-map.config';

export type StatusOption = RequestState | AuxiliaryRequestState;

@Component({
    selector: 'app-request-status',
    templateUrl: './request-status.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestStatusComponent {
    public statusOptions = input.required<StatusOption[]>();
    public activeStatuses = input.required<StatusOption[]>();
    public disabled = input<boolean>(false);

    public activeStatusesChange = output<StatusOption[]>();

    protected statusColorMap = statusColorMap;

    protected isActive(status: StatusOption): boolean {
        return this.activeStatuses().includes(status);
    }

    protected toggle(status: StatusOption): void {
        if (this.disabled()) return;

        const current = this.activeStatuses();
        const active = this.isActive(status);

        // Prevent deselecting the last active status
        if (active && current.length === 1) return;

        const next = active ? current.filter((s) => s !== status) : [...current, status];
        this.activeStatusesChange.emit(next);
    }
}
